import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: BASE });

// attach admin token if present
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('hitera_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// -------- Public --------
export const fetchProducts = (params = {}) => api.get('/products', { params }).then((r) => r.data);
export const fetchProduct = (id) => api.get(`/products/${id}`).then((r) => r.data);
export const fetchCategories = () => api.get('/categories').then((r) => r.data);
export const createOrder = (payload) => api.post('/orders', payload).then((r) => r.data);
export const sendContact = (payload) => api.post('/contact', payload).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post('/newsletter', { email }).then((r) => r.data);

// -------- Admin --------
export const adminLogin = (username, password) => api.post('/admin/login', { username, password }).then((r) => r.data);
export const adminStats = () => api.get('/admin/stats').then((r) => r.data);
export const adminSales = () => api.get('/admin/sales').then((r) => r.data);
export const adminCreateProduct = (p) => api.post('/products', p).then((r) => r.data);
export const adminUpdateProduct = (id, p) => api.put(`/products/${id}`, p).then((r) => r.data);
export const adminDeleteProduct = (id) => api.delete(`/products/${id}`).then((r) => r.data);
export const adminSetStock = (id, stock) => api.patch(`/products/${id}/stock`, { stock }).then((r) => r.data);
export const adminAddCategory = (c) => api.post('/categories', c).then((r) => r.data);
export const adminDeleteCategory = (slug) => api.delete(`/categories/${slug}`).then((r) => r.data);
export const adminListOrders = () => api.get('/orders').then((r) => r.data);
export const adminSetOrderStatus = (id, status) => api.patch(`/orders/${id}/status`, { status }).then((r) => r.data);
export const adminUpdateOrder = (id, payload) => api.put(`/orders/${id}`, payload).then((r) => r.data);
export const adminDeleteOrder = (id) => api.delete(`/orders/${id}`).then((r) => r.data);
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
export const uploadVideo = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/upload/video', fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 }).then((r) => r.data);
};

// -------- Reviews --------
export const fetchReviews = (productId) => api.get(`/products/${productId}/reviews`).then((r) => r.data);
export const postReview = (productId, payload) => api.post(`/products/${productId}/reviews`, payload).then((r) => r.data);
export const adminListReviews = () => api.get('/reviews').then((r) => r.data);
export const adminDeleteReview = (id) => api.delete(`/reviews/${id}`).then((r) => r.data);

// -------- Client Reviews (shareable page) --------
export const uploadReviewPhoto = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/client-reviews/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 }).then((r) => r.data);
};
export const submitClientReview = (payload) => api.post('/client-reviews', payload).then((r) => r.data);
export const fetchClientReviews = (params = {}) => api.get('/client-reviews', { params }).then((r) => r.data);
export const adminListClientReviews = () => api.get('/admin/client-reviews').then((r) => r.data);
export const adminUpdateClientReview = (id, payload) => api.put(`/client-reviews/${id}`, payload).then((r) => r.data);
export const adminDeleteClientReview = (id) => api.delete(`/client-reviews/${id}`).then((r) => r.data);

// -------- Happy Clients --------
export const fetchHappyClients = () => api.get('/happy-clients').then((r) => r.data);
export const adminAddHappyClient = (payload) => api.post('/happy-clients', payload).then((r) => r.data);
export const adminUpdateHappyClient = (id, payload) => api.put(`/happy-clients/${id}`, payload).then((r) => r.data);
export const adminDeleteHappyClient = (id) => api.delete(`/happy-clients/${id}`).then((r) => r.data);

// -------- Spotlight --------
export const fetchSpotlight = () => api.get('/spotlight').then((r) => r.data);
export const adminSetSpotlight = (items) => api.put('/spotlight', { items }).then((r) => r.data);

// -------- Instagram --------
export const fetchInstagramPosts = (limit = 12) => api.get('/instagram/posts', { params: { limit } }).then((r) => r.data);
export const adminSetInstagramProduct = (postId, productId) => api.patch(`/instagram/posts/${postId}/product`, { product_id: productId }).then((r) => r.data);
export const adminSuggestInstagram = () => api.post('/instagram/suggest').then((r) => r.data);

export default api;
